'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryProvinceSelector = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountryProvinceSelector = exports.CountryProvinceSelector = function () {
  function CountryProvinceSelector(countryElement, provinceElement) {
    var _this = this;

    (0, _classCallCheck3.default)(this, CountryProvinceSelector);

    this.countryElement = countryElement;
    this.provinceElement = provinceElement;

    this.countryElement.on('change', function (e) {
      return _this.onChange(e);
    });

    this.useCountry(countryElement.val());

    if (this.provinceElement.attr('data-value')) {
      //TODO: This may need error checking? e.g. if a selected province does not exist
      this.provinceElement.val(this.provinceElement.attr('data-value'));
    }
  }

  (0, _createClass3.default)(CountryProvinceSelector, [{
    key: 'useCountry',
    value: function useCountry(country) {
      var isEmpty = !country || !country.length || country == '---';

      var provinces = [];
      if (!isEmpty) {
        var optionTag = this.countryElement.find('[value="' + country + '"]');
        provinces = JSON.parse(optionTag.attr('data-provinces'));
      };

      if (isEmpty || !provinces.length) {
        this.provinceElement.html('');
        this.provinceElement.addClass('is-hidden');
        this.provinceElement.closest('.o-form__input-group').addClass('is-hidden');
        return;
      }

      //Get the HTML
      var x = provinces.reduce(function (x, province) {
        var _province = (0, _slicedToArray3.default)(province, 2),
            value = _province[0],
            name = _province[1];

        return x + '<option value="' + value + '">' + name + '</option>';
      }, '');
      this.provinceElement.html(x);
      this.provinceElement.closest('.o-form__input-group').removeClass('is-hidden');
      this.provinceElement.removeClass('is-hidden');
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var self = (0, _jquery2.default)(e.currentTarget);
      var value = self.val();
      this.useCountry(value);
    }
  }]);
  return CountryProvinceSelector;
}();